module.exports = __webpack_public_path__ + "img/emba_dy_g.2cb9550a.png";